// Update URL here after backend ready
const COMMON_URL = `${process.env.REACT_APP_SI_ORIGIN_URL}`

const EssDocsApiUrls = {
  SSO_ESSDOCS: `${COMMON_URL}/essdocs/sso`,
  GET_SI_CONFIG: `${COMMON_URL}/config/hdr/get`,
}

export default EssDocsApiUrls
